export interface PageSectionProps {
  children?: React.ReactNode;
  width?: "default" | "narrow";
}

export function PageSection({ children, width }: PageSectionProps) {
  return (
    <section className="PageSection" data-width={width}>
      {children}
    </section>
  );
}
